"use strict";
/**
 * External Dependencies
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * NAV
 */
// Grab HTML Elements
const body = document.body;
const hamburger = document.querySelector('button.nav-hamburger');
let wpkTimeOut;
window.addEventListener('resize', () => {
    body.classList.add('resize');
    if (!wpkTimeOut) {
        wpkTimeOut = setTimeout(function () {
            body.classList.remove('resize');
            wpkTimeOut = null;
        }, 500);
    }
}, { passive: true });
// Add Event Listeners
hamburger === null || hamburger === void 0 ? void 0 : hamburger.addEventListener('click', () => {
    body.classList.toggle('open');
});
/**
* BUY NOW BUTTON
*/
const observer = new IntersectionObserver(([e]) => {
    e.target.classList.toggle('stuck', e.intersectionRatio < 1);
    if (e.boundingClientRect.top < 0) {
        e.target.classList.remove('stuck'); //Remove class when button is above viewport
    }
}, { threshold: [1] });
const sticky = document.querySelector('#woocommerce.single div.buy-now');
sticky ? observer.observe(sticky) : false;
/**
* HEADER NAV
*/
const headerNavButtons = document.querySelectorAll('nav#nav-main li.menu-item-has-children > a');
headerNavButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
        const target = event.target;
        if (target.className === 'dropdown') {
            event.preventDefault();
            button.classList.toggle('active');
        }
    });
});
/**
* FOOTER NAV
*/
const footerNavButtons = document.querySelectorAll('footer .widget_nav_menu');
footerNavButtons.forEach((button) => {
    button.addEventListener('click', () => {
        button.classList.toggle('active');
    });
});
/**
* VIDEO BLOCK
*/
const videos = document.querySelectorAll('.wp-block-karopharma-video');
videos.forEach((video) => {
    const trigger = video.querySelector('.video-trigger');
    trigger && trigger.addEventListener('click', () => {
        const iframe = video.querySelector('iframe');
        const img = video.querySelector('picture');
        if (iframe != null && typeof iframe.getAttribute == 'function' && iframe.getAttribute('data-src') != null && typeof iframe.getAttribute('data-src') == 'string') {
            iframe.setAttribute('src', iframe.getAttribute('data-src') || '');
        }
        trigger.remove();
        img && img.remove();
    });
});
/**
* Find out if element is in viewport
*/
function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
}
/**
* Remove lazy load on images in viewport
*/
const lazyImages = document.querySelectorAll('main img');
if (lazyImages) {
    lazyImages.forEach(lazyImage => {
        const visible = isElementInViewport(lazyImage);
        if (visible === true) {
            lazyImage.loading = 'eager';
        }
    });
}
/**
* Style footer navs
*/
const footerNavs = document.querySelectorAll('#footer-main .post-nav-list, #footer-main .menu-nav-list');
if (footerNavs) {
    footerNavs.forEach((footerNav, index) => {
        var _a;
        if (index === 0)
            return;
        (_a = footerNav.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('widget_block_nav_list');
    });
}
/**
* Set HCP modal cookie
*/
const karoModal = document.getElementById('karo-modal');
if (karoModal != null) {
    document.cookie.indexOf('karo_hcp') == -1 ? karoModal.style.display = 'block' : karoModal.remove(); //Run JS double check because of CloudFlare chache on php file
    karoModal === null || karoModal === void 0 ? void 0 : karoModal.addEventListener('click', (event) => {
        var _a;
        if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.id) === 'karo-hcp-true') {
            if (karoModal.dataset.type === 'page') {
                document.cookie = 'karo_hcp=true; path=' + window.location.href + '; SameSite=Strict;'; //No expire = session cookie
            }
            else {
                document.cookie = 'karo_hcp=true; path=/; SameSite=Strict;'; //No expire = session cookie
            }
            karoModal.remove();
        }
    });
}
/**
* Plikttext
*/
const karoPlikttext = document.getElementById('plikttext');
const karoPlikttextLabel = karoPlikttext === null || karoPlikttext === void 0 ? void 0 : karoPlikttext.querySelector('#plikttext-checkbox_label');
const karoPlikttextCheckbox = karoPlikttext === null || karoPlikttext === void 0 ? void 0 : karoPlikttext.querySelector('#plikttext-checkbox');
const karoPlikttextDescription = karoPlikttext === null || karoPlikttext === void 0 ? void 0 : karoPlikttext.querySelector('#plikttext-description');
const plikttextPlus = karoPlikttext === null || karoPlikttext === void 0 ? void 0 : karoPlikttext.querySelector("#plikttext-checkbox_label .fa-plus");
const plikttextMinus = karoPlikttext === null || karoPlikttext === void 0 ? void 0 : karoPlikttext.querySelector("#plikttext-checkbox_label .fa-minus");
karoPlikttextLabel === null || karoPlikttextLabel === void 0 ? void 0 : karoPlikttextLabel.addEventListener('click', () => {
    const checkboxValue = karoPlikttextCheckbox.checked === false ? true : false;
    sessionStorage.setItem('plikttext', new Boolean(checkboxValue).toString());
    karoPlikttextDescription === null || karoPlikttextDescription === void 0 ? void 0 : karoPlikttextDescription.classList.toggle('hidden');
    plikttextPlus === null || plikttextPlus === void 0 ? void 0 : plikttextPlus.classList.toggle('hidden');
    plikttextMinus === null || plikttextMinus === void 0 ? void 0 : plikttextMinus.classList.toggle('hidden');
});
const plikttextValue = sessionStorage.getItem('plikttext');
if (plikttextValue !== null && plikttextValue == 'false') {
    karoPlikttextCheckbox.checked = false;
    plikttextPlus === null || plikttextPlus === void 0 ? void 0 : plikttextPlus.classList.remove('hidden');
    plikttextMinus === null || plikttextMinus === void 0 ? void 0 : plikttextMinus.classList.add('hidden');
    karoPlikttextDescription === null || karoPlikttextDescription === void 0 ? void 0 : karoPlikttextDescription.classList.add('hidden');
}
const printMaterialForm = document.querySelector('.print-material-container');
const sendMaterialRequestEmail = () => __awaiter(void 0, void 0, void 0, function* () {
    const mailDetails = getMailDetails();
    if (mailDetails) {
        const result = yield fetch("/wp-admin/admin-ajax.php?action=print_material_form_send", {
            method: 'POST',
            body: JSON.stringify(getMailDetails()),
            headers: {
                "Content-Type": "application/json",
            },
        });
        return yield result.json()
            .then(data => data);
    }
    else {
        throw new Error("Validation error");
    }
});
if (printMaterialForm) {
    const submitButton = printMaterialForm.querySelector('.print-material_order-form_submit');
    submitButton === null || submitButton === void 0 ? void 0 : submitButton.addEventListener('click', () => {
        sendMaterialRequestEmail().then(result => {
            var _a, _b, _c, _d;
            if (result.success) {
                (_a = printMaterialForm.querySelector('#print-material_order-form_message-success')) === null || _a === void 0 ? void 0 : _a.classList.remove('hidden');
                (_b = printMaterialForm.querySelector('#print-material_order-form_message-error')) === null || _b === void 0 ? void 0 : _b.classList.add('hidden');
            }
            else {
                (_c = printMaterialForm.querySelector('#print-material_order-form_message-success')) === null || _c === void 0 ? void 0 : _c.classList.add('hidden');
                (_d = printMaterialForm.querySelector('#print-material_order-form_message-error')) === null || _d === void 0 ? void 0 : _d.classList.remove('hidden');
            }
        }).catch(() => {
            var _a, _b;
            (_a = printMaterialForm.querySelector('#print-material_order-form_message-success')) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
            (_b = printMaterialForm.querySelector('#print-material_order-form_message-error')) === null || _b === void 0 ? void 0 : _b.classList.remove('hidden');
        });
    });
}
const getMailDetails = () => {
    let valid = true;
    const body = {
        name: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print-material_order-form_name')).value,
        email: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print-material_order-form_email')).value,
        employer: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print-material_order-form_employer')).value,
        adress: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print-material_order-form_address')).value,
        zipcode: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print-material_order-form_zipcode')).value,
        city: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print-material_order-form_city')).value,
        nonce: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print_material_form_nonce_field')).value,
        r: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print-material_order-form_r')).value,
        s: (printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelector('#print-material_order-form_s')).value,
        material: [],
    };
    const materialBlocks = printMaterialForm === null || printMaterialForm === void 0 ? void 0 : printMaterialForm.querySelectorAll('.print-material-block');
    materialBlocks === null || materialBlocks === void 0 ? void 0 : materialBlocks.forEach(el => {
        var _a, _b;
        const select = el.querySelector('select');
        if (select) {
            const materialBlock = {
                amount: select.options[select.selectedIndex].value,
                title: (_b = (_a = el.querySelector('.print-material-title')) === null || _a === void 0 ? void 0 : _a.innerHTML) !== null && _b !== void 0 ? _b : '',
            };
            body.material.push(materialBlock);
        }
    });
    // Validates that the form is filled out
    for (const [key, value] of Object.entries(body)) {
        if (!value) {
            valid = false;
            throw new Error(`${key} is required `);
        }
    }
    if (valid) {
        return body;
    }
    else {
        return null;
    }
};
/**
 * Sound block functions
 */
const audioPlayers = document.querySelectorAll('.sound-block-player');
let currentlyPlayingAudioPlayer;
let soundBlocksPaused = true;
const getTimerText = (timerLength) => {
    const minutes = Math.floor(timerLength / 60);
    const seconds = timerLength % 60;
    function str_pad_left(string, pad, length) {
        return (new Array(Number(length) + 1).join(String(pad)) + string).slice(-length);
    }
    return (str_pad_left(String(minutes), '0', 2) + ':' + str_pad_left(String(seconds), '0', 2));
};
const createSoundsBlockInterval = () => {
    const soundsTimer = document.querySelector('#sounds-timer');
    const timerCompletionText = document.querySelector('#sounds-completed');
    if (soundsTimer) {
        const timerLength = Number(soundsTimer.getAttribute('data-timer-length'));
        let newTimerLength = timerLength;
        const soundBlocksTimer = setInterval(() => {
            var _a;
            if (newTimerLength <= 0) {
                clearInterval(soundBlocksTimer);
                soundsTimer.innerHTML = (_a = timerCompletionText === null || timerCompletionText === void 0 ? void 0 : timerCompletionText.innerHTML) !== null && _a !== void 0 ? _a : "Completed";
            }
            else {
                soundsTimer.innerHTML = getTimerText(newTimerLength);
            }
            if (!soundBlocksPaused) {
                newTimerLength -= 1;
            }
        }, 1000);
        return soundBlocksTimer;
    }
};
const playAudio = (player) => {
    // Checks if the used is pausing the actively playing
    // music or starts a different audio player
    if (player === currentlyPlayingAudioPlayer) {
        if (!player.paused) {
            soundBlocksPaused = true;
            player.pause();
        }
        else {
            soundBlocksPaused = false;
            void player.play()
                .catch((e) => console.error(e));
        }
    }
    else {
        audioPlayers.forEach((el) => {
            void el.pause();
        });
        soundBlocksPaused = false;
        player.play()
            .then(() => currentlyPlayingAudioPlayer = player)
            .catch((e) => console.error(e));
    }
};
/**
 * Sound block
 */
if (audioPlayers) {
    // Generates a timer
    createSoundsBlockInterval();
    for (let i = 0; i < audioPlayers.length; i++) {
        const audioPlayer = audioPlayers[i];
        const playButton = audioPlayers[i].nextElementSibling;
        if (playButton) {
            playButton.addEventListener('click', () => playAudio(audioPlayer));
        }
    }
}
/**
* Hide default pwd template
*/
const modalPasswordBlock = document.querySelector('.modal-password-block');
const postPasswordForm = document.querySelector('.post-password-form');
if (postPasswordForm != null && modalPasswordBlock != null) {
    window.addEventListener('DOMContentLoaded', () => {
        const computedStyles = getComputedStyle(modalPasswordBlock);
        const displayValue = computedStyles.getPropertyValue('display');
        if (displayValue === 'block' || displayValue === 'inline-block') {
            postPasswordForm.classList.add('hidden');
        }
        else {
            postPasswordForm.classList.remove('hidden');
        }
    });
}
